import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-end justify-center min-h-screen text-center sm:block sm:p-0" };
const _hoisted_2 = {
    id: "media-center",
    class: "w-full h-screen float-right bg-white",
    ref: "mediaCenterRef"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["fixed z-10 inset-0 overflow-y-auto", { hidden: !_ctx.openMediaPicker }])
    }, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, null, 512 /* NEED_PATCH */)
        ])
    ], 2 /* CLASS */));
}
